import Vue from 'vue';
import ReactiveProvide from 'vue-reactive-provide';
import { fetchABTest } from '@/common/abTest/request';
import { isB } from '@/common/abTest';
import { request } from 'root/common/request';
import config from 'root/common/config/config';
import env from '@/common/util/env';
import { getMiniEnvOfKey } from 'root/common/util/miniEnv';
import storage from 'root/common/util/storage';

const allowanceApi = `${config.fanxianDomain}/api/bwbt/allowance/v1_0/get`; // key=BWBT_ALLOWANCE_EXPLAIN
const receiveStatusApi = `${config.fanxianDomain}/api/bwbt/preOrder/v1_0/checkAndGetPreOrderRecord`;
// not necessary when used as a mixin, see below for details
Vue.use(ReactiveProvide, {
    name: 'reactiveProvide', // default value
});

export default {
    data() {
        return {
            abTestIsB: false,
            allowanceInfo: {},
            showFinishPopup: false, //是否显示补贴金弹窗
            showFinishBanner: false, //是否显示补贴金banner
            receiveStatus: '1',
            isApp: window.__is_blackApp,
        };
    },
    computed: {
        allowance() {
            const itemList = this.allowanceInfo?.itemList ?? [];
            return itemList[0]?.bwbtAllowance || 0;
        },
        abTestIsBValue() {
            return this.abTestIsB ? 'B' : 'A';
        },
        shouldShowInApp() {
            return this.isApp && this.abTestIsB;
        },
    },
    reactiveProvide: {
        name: 'provide',
        include: ['allowance', 'abTestIsB', 'receiveStatus', 'shouldShowInApp'],
    },
    created() {
        this.getAbTest();
    },
    methods: {
        getNumber(num) {
            if (typeof num !== 'number') num = parseFloat(num);
            if (Number.isNaN(num)) return 0;
            return parseFloat(num.toFixed(2));
        },
        //获取礼金计算金额接口
        async getAllowance(price = 0, currentPrice) {
            if (this.shouldShowInApp) {
                try {
                    const phpUserId = storage.get(storage.keys.memberId, { bare: true });
                    // 小程序下如果有虚拟memberId就用虚拟的
                    const virtuaMemberId = getMiniEnvOfKey('virtuaMemberId');
                    if (!phpUserId && !virtuaMemberId) return Promise.resolve(false);
                    const numPrice = this.getNumber(price);
                    const result = await request({
                        url: allowanceApi,
                        method: 'POST',
                        data: {
                            itemList: [
                                {
                                    basicAmount: numPrice,
                                    businessType: 'Recharge',
                                },
                            ],
                            phpUserId: env.isWechatMini && virtuaMemberId ? virtuaMemberId : phpUserId,
                        },
                        isNeedLoading: false,
                        isNeedToken: true,
                    });
                    if (result.code == 200) {
                        if (currentPrice) {
                            // 多次请求的情况取对应值
                            if (price !== parseFloat(currentPrice)) {
                                return;
                            }
                        }
                        this.allowanceInfo = result?.data;
                    }
                } catch (error) {
                    window.monitor.report({
                        level: 'error',
                        error: 'js',
                        url: window.location.href,
                        msg: `getAllowance error`,
                    });
                    console.error(error);
                }
            }
        },
        //获取订单礼金状态接口
        async getStatusByOrderId({ orderId }) {
            if (this.shouldShowInApp) {
                try {
                    const phpUserId = storage.get(storage.keys.memberId, { bare: true });
                    // 小程序下如果有虚拟memberId就用虚拟的
                    const virtuaMemberId = getMiniEnvOfKey('virtuaMemberId');
                    if (!phpUserId && !virtuaMemberId) return Promise.resolve(false);
                    const result = await request({
                        url: receiveStatusApi,
                        method: 'POST',
                        data: {
                            orderId,
                            businessType: 'Recharge',
                            phpUserId: env.isWechatMini && virtuaMemberId ? virtuaMemberId : phpUserId,
                        },
                        isNeedLoading: false,
                        isNeedToken: true,
                    });
                    if (result.code == 200) {
                        if (result?.data) {
                            const {
                                status = '1',
                                bwbtAllowance = 0,
                                hasQualification,
                                orderExist,
                                expiredTime,
                            } = result?.data;
                            const now = new Date().getTime();
                            const qualification = hasQualification && orderExist && status !== '3' && expiredTime > now;
                            this.receiveStatus = status;
                            this.showFinishPopup = qualification;
                            this.showFinishBanner = qualification;
                            this.allowanceInfo = {
                                itemList: [{ bwbtAllowance }],
                            };
                        } else {
                            this.receiveStatus = '1';
                            this.allowanceInfo = {};
                            this.showFinishPopup = false;
                            this.showFinishBanner = false;
                        }
                    } else {
                        this.receiveStatus = '1';
                        this.allowanceInfo = {};
                        this.showFinishPopup = false;
                        this.showFinishBanner = false;
                    }
                } catch (error) {
                    window.monitor.report({
                        level: 'error',
                        error: 'js',
                        url: window.location.href,
                        msg: `getStatusByOrderId error`,
                    });
                    console.error(error, 'getStatusByOrderId error');
                }
            }
        },
        async getAbTest() {
            this.abTestIsB = isB('bwbtAllowance');
            try {
                const data = await fetchABTest();
                this.abTestIsB = data.bwbtAllowance?.abTest === 'B';
            } catch (e) {
                window.monitor.report({
                    level: 'info',
                    error: 'js',
                    url: window.location.href,
                    msg: `fetchABTestIfNeed error`,
                });
                console.error(e);
            }
        },
    },
};
